import axios from 'axios';

const instance = axios.create({
  baseURL: 'https://uofthome.herokuapp.com/building/region/address?region=',
});

export default instance;
